/**
 * Governed location page copy — local i18n only; API supplies ids, coords, bases.
 */

import enUS from '../i18n/locales/en-US.json';
import deDE from '../i18n/locales/de-DE.json';
import { resolveSupportedLocale } from './supportedLocales';

export const LOCATION_IDS = [
  'wiesbaden',
  'kaiserslautern',
  'stuttgart',
  'grafenwoehr',
  'heidelberg',
  'frankfurt',
];

/** English API overview markers — must never appear in DE location cards. */
export const API_LOCATION_OVERVIEW_EN_MARKERS = [
  'Wiesbaden is a key US Army Europe hub',
  "Kaiserslautern — locally known as 'K-Town'",
  "Stuttgart hosts USAREUR-AF's Patch Barracks",
  'Grafenwöhr hosts the 7th Army Training Command',
  'Heidelberg was long the heart of US Army Europe',
  "Frankfurt is Germany's financial capital",
  'Higher cost of living than K-Town',
];

const LOCALE_BUNDLES = { en: enUS, de: deDE };

const NAME_TO_ID = {
  wiesbaden: 'wiesbaden',
  kaiserslautern: 'kaiserslautern',
  stuttgart: 'stuttgart',
  grafenwoehr: 'grafenwoehr',
  grafenwöhr: 'grafenwoehr',
  heidelberg: 'heidelberg',
  frankfurt: 'frankfurt',
  vilseck: 'grafenwoehr',
};

function copyKey(locationId, field) {
  return `locations.city.${String(locationId || '').toLowerCase()}.${field}`;
}

function localeBundle(locale) {
  const loc = resolveSupportedLocale(locale);
  return LOCALE_BUNDLES[loc] || enUS;
}

export function resolveLocationId(location) {
  if (!location) return '';
  const rawId = String(location.id || '').trim().toLowerCase();
  if (LOCATION_IDS.includes(rawId)) return rawId;

  const lowerName = String(location.name || '').toLowerCase();
  const matchedKey = Object.keys(NAME_TO_ID).find((token) => lowerName.includes(token));
  return matchedKey ? NAME_TO_ID[matchedKey] : rawId;
}

/** Card/detail overview and lifestyle notes — local JSON only, never API fields. */
export function getLocationCopy(location, locale) {
  const locationId = resolveLocationId(location);
  const bundle = localeBundle(locale);

  return {
    locationId,
    overview: bundle[copyKey(locationId, 'overview')] || '',
    lifestyleNotes: bundle[copyKey(locationId, 'lifestyle_notes')] || '',
  };
}
